import { render, staticRenderFns } from "./otherEmployee.vue?vue&type=template&id=4f4948d7"
import script from "./otherEmployee.vue?vue&type=script&lang=js"
export * from "./otherEmployee.vue?vue&type=script&lang=js"
import style0 from "./otherEmployee.vue?vue&type=style&index=0&id=4f4948d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports